module.exports = __webpack_public_path__ + "img/icon_wd@2x.3e694d4a.png";